// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ws","title":"e_Xs","image":"e_Ys","mobileView":"e_Zs"};